import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Receipt20 from '@carbon/icons-react/es/receipt/20';
import styled from 'styled-components';
import { SupportedPlansType } from 'api/billing/types';
import FeatureScreenshot from 'assets/feature-gating/invoices-list-feature-gating.png';
import { PageLoading } from 'components/atoms/loading';
import { MaskableContent } from 'components/atoms/maskable-content';
import { FeatureGatingModal } from 'components/molecules/feature-gating/feature-gating-modal';
import { Helium } from 'components/templates';
import { useHasAccessToInvoicing } from 'hooks/use-invoice-permission';
import { useTranslate, useTranslation } from 'hooks/use-translation';
import { useCreditNoteEssentialSettingsQuery } from 'queries/credit-note-settings';
import { useFeatureSettings } from '../use-feature-setting';
import { Divider, Section } from './components';
import { CreditNoteTitle } from './credit-note-title';
import { DefaultNotesSettings } from './default-notes';
import { FeatureSwitch } from './feature-switch';
import { CreditNoteNumberSettings } from './note-number';
import { ReasonCodeSettings } from './reason-code';
import { ReasonDescriptionSettings } from './reason-description';
const Wrapper = styled.div`
  padding-bottom: var(--layout-07);
`;
export const CreditNoteEssentialSettings = ()=>{
    const translate = useTranslate();
    const hasAccessToInvoicing = useHasAccessToInvoicing();
    const { data, isLoading } = useCreditNoteEssentialSettingsQuery({
        refetchOnMount: true,
        refetchOnWindowFocus: true
    });
    const documentTitle = useTranslation('settings.credit_notes_essentials.title');
    const [featureEnabled, setFeatureEnabled] = useFeatureSettings();
    return /*#__PURE__*/ _jsxs(Helium, {
        icon: /*#__PURE__*/ _jsx(Receipt20, {}),
        documentTitle: documentTitle,
        children: [
            !hasAccessToInvoicing && /*#__PURE__*/ _jsx(FeatureGatingModal, {
                planType: SupportedPlansType.Premium,
                title: translate('invoices.feature_gating.title'),
                description: translate('invoices.feature_gating.description'),
                featureImage: FeatureScreenshot,
                learnMoreLink: "https://help.rocketlane.com/support/solutions/folders/67000581853"
            }),
            /*#__PURE__*/ _jsx("section", {
                children: /*#__PURE__*/ _jsx(FeatureSwitch, {
                    enabled: featureEnabled,
                    onStateChange: setFeatureEnabled
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {}),
            /*#__PURE__*/ _jsx(MaskableContent, {
                showMask: !featureEnabled,
                "data-cy": "timesheet-settings-content",
                children: isLoading || !data ? /*#__PURE__*/ _jsx(PageLoading, {}) : /*#__PURE__*/ _jsxs(Wrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Section, {
                            children: /*#__PURE__*/ _jsx(CreditNoteNumberSettings, {
                                creditNotePrefix: data.creditNotePrefix,
                                nextCreditNoteNumber: data.nextCreditNoteNumber,
                                isAllowedToEditCreditNoteNumber: data.allowUsersToEditCreditNoteNumber
                            })
                        }),
                        /*#__PURE__*/ _jsx(Divider, {}),
                        /*#__PURE__*/ _jsx(Section, {
                            children: /*#__PURE__*/ _jsx(CreditNoteTitle, {
                                creditNoteTitle: data.creditNoteDisplayTitle
                            })
                        }),
                        /*#__PURE__*/ _jsx(Divider, {}),
                        /*#__PURE__*/ _jsx(Section, {
                            children: /*#__PURE__*/ _jsx(ReasonCodeSettings, {
                                reasonMandatory: data.reasonMandatory
                            })
                        }),
                        /*#__PURE__*/ _jsx(Divider, {}),
                        /*#__PURE__*/ _jsx(Section, {
                            children: /*#__PURE__*/ _jsx(ReasonDescriptionSettings, {
                                reasonDescriptionMandatory: data.reasonDescriptionMandatory
                            })
                        }),
                        /*#__PURE__*/ _jsx(Divider, {}),
                        /*#__PURE__*/ _jsx(Section, {
                            children: /*#__PURE__*/ _jsx(DefaultNotesSettings, {
                                defaultNotes: data.defaultNotes
                            })
                        })
                    ]
                })
            })
        ]
    });
};
